import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers";
import companyMiddleware from "./middleware/companyMiddleware";
import { COMPANY_CHECKING } from "./types";

const persistConfig = {
  key: "rkmi",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    }).concat(companyMiddleware)
});

const persistor = persistStore(store);

persistor.subscribe(() => {
  if (persistor.getState().bootstrapped) {
    // Remove the navigate parameter if it's not needed in the action
    store.dispatch({ type: COMPANY_CHECKING });
  }
});

export { store, persistor };
